import React, { Component } from 'react'

import Colors from '../../../themes/Colors'

import ResponsiveContainer from '../../core/ResponsiveContainer'

import SectionHeading from '../common/SectionHeading'

import Section from './components/Section'
import {
  SectionContainer,
  SectionDescription,
  Wrapper
} from './styledComponents'

class ExperimentalMarketingSection extends Component {
  renderImageAndContentSection = (section, index) => {
    const { formData, glsLoaded } = this.props
    const {
      sectionid,
      title,
      description,
      mainImage,
      mobileImage,
      buttonText,
      videoId
    } = section
    return (
      <Section
        id={sectionid.toLowerCase()}
        key={title}
        futureItemDescription={description}
        futureItemTitle={title}
        isEven={index % 2 === 0}
        mainImage={mainImage}
        mobileimage={mobileImage}
        videoId={videoId}
        buttonText={buttonText}
        formData={formData}
        glsLoaded={glsLoaded}
      />
    )
  }

  render() {
    const {
      sectionId,
      experientialMarketingWithibcData,
      invertTheme
    } = this.props
    const {
      title,
      description,
      sectionsData
    } = experientialMarketingWithibcData
    return (
      <SectionContainer
        id={sectionId}
        ref={c => {
          this.section = c
        }}
        invertTheme={invertTheme}
      >
        <ResponsiveContainer>
          <Wrapper>
            <SectionHeading
              sectionHeadingText={title}
              color={Colors.oceanBlue}
            />
            <SectionDescription
              as="p"
              dangerouslySetInnerHTML={{ __html: description }}
            />
            {sectionsData.map((section, index) =>
              this.renderImageAndContentSection(section, index)
            )}
          </Wrapper>
        </ResponsiveContainer>
      </SectionContainer>
    )
  }
}
export default ExperimentalMarketingSection



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/ExperimentalMarketingSection/index.js